import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{

  constructor(private route: ActivatedRoute,private router: Router){
    
  }

  verificarVersao(){
    fetch("https://www.diviprev.mg.gov.br/arquivador/versao/numero.txt").then(res=>res.text()).then(r=>{
      console.log("ver->"+r);
      let valor = localStorage.getItem('VERSAO');
      if(!valor || valor!=r){
        localStorage.setItem('VERSAO',r);
        window.location.reload();
      }
    });
  }

  sub:any;
  categoria:string;
  ngOnInit(): void {
    this.verificarVersao();
    this.sub = this.route.params.subscribe(params => {
      this.categoria = params['categoria']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
      this.router.navigate(['/arquivos',this.categoria]);
   });
    
  }
  title = 'Arquivos - Diviprev';
}
